import { useRef } from "react";
import { Trash2 } from "lucide-react";
import { COLUMNS, STATUS_DOT } from "@/components/settings/bulkTaxonomyHelpers";
import BulkTaxonomyCell from "@/components/settings/bulkTaxonomy/BulkTaxonomyCell";

export default function BulkTaxonomyGrid({
  rows, depts, caseTypes,
  errorsByRow, statusByRow,
  onUpdateCell, onDeleteRow, onAddRow, onPaste,
  registerRow,
}) {
  const containerRef = useRef(null);

  return (
    <div ref={containerRef} className="flex-1 overflow-auto -mx-6 px-1 border-b border-slate-200">
      <table className="w-full text-xs" data-testid="taxonomy-grid">
        <thead className="sticky top-0 bg-slate-50 border-b border-slate-200 z-10">
          <tr className="text-[10px] uppercase tracking-wider text-slate-500">
            <th className="px-2 py-2 text-center w-10">#</th>
            <th className="px-2 py-2 text-center w-8" title="Status after Validate">●</th>
            {COLUMNS.map((c) => (
              <th key={c.key} className={`px-2 py-2 text-left font-semibold ${c.w}`}>{c.header}</th>
            ))}
            <th className="px-2 py-2 w-10"></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => {
            const status = statusByRow[i];
            const dot = STATUS_DOT[status];
            const cellErrs = errorsByRow[i] || {};
            const hasErr = Object.keys(cellErrs).length > 0;
            return (
              <tr key={row._rid || `r-${i}`}
                  ref={(el) => registerRow(i, el)}
                  className={`border-b border-slate-100 transition ${hasErr ? "bg-rose-50/40 hover:bg-rose-50/70" : "hover:bg-slate-50/60"}`}>
                <td className="text-center text-slate-400 font-mono">{i + 1}</td>
                <td className="text-center">
                  {dot && <span className={`inline-block w-2.5 h-2.5 rounded-full ring-2 ${dot.color}`} title={dot.label} />}
                </td>
                {COLUMNS.map((c) => (
                  <BulkTaxonomyCell
                    key={c.key} col={c} value={row[c.key]} error={cellErrs[c.key]}
                    depts={depts} caseTypes={caseTypes}
                    onChange={(v) => onUpdateCell(i, c.key, v)}
                    onPaste={(e) => onPaste(e, i, c.key)}
                  />
                ))}
                <td className="text-center">
                  <button onClick={() => onDeleteRow(i)} className="text-rose-500 hover:text-rose-700 p-1" data-testid={`del-row-${i}`}>
                    <Trash2 className="w-3.5 h-3.5" />
                  </button>
                </td>
              </tr>
            );
          })}
          <tr>
            <td colSpan={COLUMNS.length + 3} className="text-center text-xs text-slate-400 py-2 hover:text-indigo-600 cursor-pointer hover:bg-slate-50"
                onClick={onAddRow}>＋ Add row (or paste here)</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
